/**
 * @description Capitalises the 1st character of each string with or without expected delimiter.
 * @param {string} value single or multi word sentence 
 * @param {string} delimiter delimiter to split and join back to. 
 * @returns {string} transforms: 'my sentence' to 'My Sentence' or 'string' to 'String'
 */
export const capitaliseFirstLetter = (value, delimiter = ' ') => {

    if(value === null || value === undefined) { return ''; }

    const capitalised = value
        .split(delimiter)
        .map((p) => (`${p.charAt(0).toUpperCase()}${p.substring(1)}`));

    return capitalised
        .join(delimiter);
};

/**
 * @description replaces the current delimiter in the provided string value with a specified replacement delimiter.
 
 * @param {string} value 
 * @param {char | string} currentDelimiter defaults to 'single white space'
 * @param {char | string} replaceWithDelimiter defaults to '-'
 * @returns {string} transforms: 'Good morning' - 'Good-morning' or 'string' to string 
 */
export const updateWithDelimiter = (value, currentDelimiter = ' ', replaceWithDelimiter = '-') => {

    if(value === null || value === undefined) { return ''; }

    const parts = value
        .split(currentDelimiter);

    return parts
        .join(replaceWithDelimiter);
};